import { render, staticRenderFns } from "./StatusIQCustomization.vue?vue&type=template&id=71fc3742&scoped=true"
import script from "./StatusIQCustomization.vue?vue&type=script&lang=js"
export * from "./StatusIQCustomization.vue?vue&type=script&lang=js"
import style0 from "./StatusIQCustomization.vue?vue&type=style&index=0&id=71fc3742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc3742",
  null
  
)

export default component.exports